import { render } from "./chat_records.vue?vue&type=template&id=f3c73dcc"
import script from "./chat_records.vue?vue&type=script&lang=js"
export * from "./chat_records.vue?vue&type=script&lang=js"

import "./chat_records.vue?vue&type=style&index=0&id=f3c73dcc&lang=css"

import exportComponent from "D:\\web\\userBehavior-course\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__